export const TrackerObjectiveValueTypes = {
  CHECKBOX: 'checkbox',
  CHECK_GRADE: 'check_grade',
  RUBRIC_ZERO_FOUR: 'rubric_zero_four',
  NUMBER: 'number',
  TEXT: 'text',
  RUBRIC_A_TO_F: 'rubric_a_to_f',
  CUSTOM: 'custom',
  PERFORMANCE: 'performance'
};

export const AssignmentStatusOptions = {
  ASSIGNED: 'assigned',
  REVISE: 'revise',
  SUBMITTED: 'submitted',
  COMPLETE: 'complete'
};

export const AssignmentTaskValueTypes = {
  CHECKBOX: 'checkbox',
  CHECK_GRADE: 'check_grade',
  RUBRIC_ZERO_FOUR: 'rubric_zero_four',
  NUMBER: 'number',
  TEXT: 'text',
  RUBRIC_A_TO_F: 'rubric_a_to_f',
  CUSTOM: 'custom',
  PERFORMANCE: 'performance'
};

export const AssignmentTaskValueTypeValueRange = {
  [AssignmentTaskValueTypes.RUBRIC_ZERO_FOUR]: [0, 1, 2, 3, 4],
  [AssignmentTaskValueTypes.RUBRIC_A_TO_F]: ['A', 'B', 'C', 'D', 'F'],
  [AssignmentTaskValueTypes.PERFORMANCE]: [
    'beginning',
    'approaching',
    'proficient',
    'excelling'
  ]
};

export const AssignmentDepthOptions = {
  TASK: 1,
  CRITERIA: 2
};

export const ASSIGNMENT_CREATE_STEPS = {
  CREATE: 'create',
  PREPARE: 'prepare',
  REVIEW: 'review'
};

export const ASSIGNMENT_CREATE_MODES = {
  SCRATCH: 'scratch',
  TEMPLATE: 'template'
};

export const IS_ACCELERATED_CURRICULUM_FILTER = 'isAcceleratedCurriculumFilter';
